// src/components/TimeSelector.tsx
import React from 'react';
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent
} from '@mui/material';

type Props = {
  timeSlots: string[];
  selectedTime: string;
  onSelect: (time: string) => void;
};

export default function TimeSelector({ timeSlots, selectedTime, onSelect }: Props) {
  const handleChange = (event: SelectChangeEvent) => {
    onSelect(event.target.value);
  };

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id="time-select-label">Time</InputLabel>
        <Select
          labelId="time-select-label"
          value={selectedTime}
          label="Time"
          onChange={handleChange}
        >
          {timeSlots.map((slot) => (
            <MenuItem key={slot} value={slot}>
              {slot}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
